// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".e5JC8UMedbi9_j {\n  padding: 12px 12px 0 12px;\n}\n.UINRQ_b8Kr0Guj {\n  width: 100%;\n}\n._3t8n9i7Dvce-Me {\n  font-size: 12px;\n  color: #EB5A46;\n}\n._2x9guUtKQfVCBB {\n  font-size: 12px;\n  color: #EB5A46;\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"addAccount": "e5JC8UMedbi9_j",
	"email": "UINRQ_b8Kr0Guj",
	"addAccountError": "_3t8n9i7Dvce-Me",
	"notFoundError": "_2x9guUtKQfVCBB"
};
export default ___CSS_LOADER_EXPORT___;
